import { Directive, HostListener } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[disable-cut]'
})
export class DisableCutDirective {
    @HostListener('cut', ['$event'])
    blockCut(e: ClipboardEvent): void {
        e.preventDefault();
    }
}

@Directive({
    standalone: false,
    selector: '[disable-paste]'
})
export class DisablePasteDirective {
    @HostListener('paste', ['$event'])
    blockPaste(e: ClipboardEvent): void {
        e.preventDefault();
    }

    // A drag & drop �tj�n bem�solt sz�veget is megakad�lyozza
    @HostListener('drop', ['$event'])
    blockDrop(e: DragEvent): void {
        e.preventDefault();
    }
}

@Directive({
    standalone: false,
    selector: '[disable-copy]'
})
export class DisableCopyDirective {
    @HostListener('copy', ['$event'])
    blockCopy(e: ClipboardEvent): void {
        e.preventDefault();
    }
}